import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

@Component({
    data() {
        return {
            check: false
        };
    },
    components: {
        ValidationProvider
    },
    inheritAttrs: false
})
export default class Checkbox extends Vue {
    @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

    @Prop([Boolean, String, Number])
    value: boolean | string | number;

    @Prop()
    label: string;

    @Prop({ default: 'check' })
    inputName: string;

    @Prop()
    subtitle: string;

    check: boolean | string | number;

    created() {
        this.check = this.value;
    }

    get trueValue() {
        return this.$attrs['true-value'];
    }

    get falseValue() {
        return this.$attrs['false-value'];
    }

    get hasCustomValue() {
        return this.trueValue !== null &&
            this.trueValue !== undefined &&
            this.falseValue !== null &&
            this.falseValue !== undefined;
    }

    get disabled() {
        return this.$attrs['disabled'];
    }

    get checked() {
        return typeof this.check === 'boolean' || !this.hasCustomValue
            ? this.check
            : this.check === this.trueValue;
    }

    invertCheck() {
        if (this.disabled) {
            return;
        }

        this.check = typeof this.check === 'boolean' || !this.hasCustomValue
            ? !this.check
            : this.falseValue;
    }

    @Watch('check')
    change(value: boolean | string | number) {
        this.$emit('input', value);
    }

    @Watch('value')
    onChangeValue() {
        this.check = this.value;
    }
}
